import React from 'react';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { useFields, usePageMessages } from 'apps/auth/hooks/selectors';

import InputAutoDetect from '../form/InputAutoDetect';
import { getSortFields } from '../form-multi/utils';

const NewAccountScreen = (props) => {
    const fields = useFields(props.formName);
    const { requestCreateFromNewAccountTitle } = usePageMessages();

    return (
        <>
            <HeaderPanel title={requestCreateFromNewAccountTitle} />
            {fields &&
                getSortFields(fields)
                    .filter((f) => f?.visible)
                    .map((field) => {
                        if (field?.destination === 'TO') {
                            return (
                                <Row indent="adaptive-32-48" key={field.name}>
                                    <InputAutoDetect field={field} formName={props.formName} />
                                </Row>
                            );
                        }
                    })}
        </>
    );
};

export default NewAccountScreen;
